import { render, staticRenderFns } from "./LabelBox.vue?vue&type=template&id=d8538932&scoped=true&"
import script from "./LabelBox.vue?vue&type=script&lang=js&"
export * from "./LabelBox.vue?vue&type=script&lang=js&"
import style0 from "./LabelBox.vue?vue&type=style&index=0&id=d8538932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8538932",
  null
  
)

export default component.exports